import {
    $, addAction, INIT, addFilter,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.slider').each((i, e) => {
        $('.slider__slides', e).slick({
            slidesToShow: 1,
            fade: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dotsClass: 'slider__nav-dots',
            appendDots: $('.slider__nav', e),
            prevArrow: $('.slider__nav-prev', e),
            nextArrow: $('.slider__nav-next', e),
        });
    });
});

addFilter('playerArgs/youtube', (args) => ({ ...args, host: 'https://www.youtube-nocookie.com' }));
